import { render } from "./mute-button.vue?vue&type=template&id=7fe4a27c"
import script from "./mute-button.vue?vue&type=script&lang=js"
export * from "./mute-button.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__